import React from 'react';
import { Link } from 'react-router-dom';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Button } from '../ui/Button';
import { ArrowRight, CheckCircle } from 'lucide-react';
export function CTASection() {
  return <SectionWrapper background="dark" className="text-center" data-id="element-141">
      <div className="max-w-3xl mx-auto" data-id="element-142">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 tracking-tight" data-id="element-143">
          Start exploring D2D Guides
        </h2>
        <p className="text-lg text-slate-300 mb-10 leading-relaxed" data-id="element-144">
          Join thousands of operators and reps making data-driven decisions.
          Access our independent analysis today.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10" data-id="element-145">
          <Link to="/guides" data-id="element-146">
            <Button variant="primary" size="lg" data-id="element-147">
              Browse All Guides
            </Button>
          </Link>
          <Link to="/methodology" data-id="element-148">
            <Button variant="outline" size="lg" className="bg-transparent text-white border-slate-600 hover:bg-slate-800 hover:text-white hover:border-slate-500" data-id="element-149">
              Read Methodology
            </Button>
          </Link>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-xs font-medium text-slate-400" data-id="element-150">
          <span className="flex items-center" data-id="element-151">
            <CheckCircle className="w-3 h-3 mr-2 text-teal-500" data-id="element-152" /> 6 Industries
          </span>
          <span className="flex items-center" data-id="element-153">
            <CheckCircle className="w-3 h-3 mr-2 text-teal-500" data-id="element-154" /> 40+ Guides
          </span>
          <span className="flex items-center" data-id="element-155">
            <CheckCircle className="w-3 h-3 mr-2 text-teal-500" data-id="element-156" /> Editorially
            Independent
          </span>
        </div>
      </div>
    </SectionWrapper>;
}